import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router'

import { AnyType } from '@centra/centra-ui'

import { checkDisabledLocation } from './utils'

const ScrollToTop: FC = props => {
  const { children } = props
  const location = useLocation()

  useEffect(() => {
    const isDisabled = checkDisabledLocation(location) || (location?.state as AnyType)?.blockScrollTop

    if (!isDisabled) {
      window.scrollTo(0, 0)
    }
  }, [location])

  return <>{children}</>
}

export default ScrollToTop
